import { Button, Input, Select, Tooltip } from 'antd';
import Table from 'antd/es/table';
import { useEffect, useState } from 'react';
import { useEvent, useStore } from 'effector-react';
import { InfoOutlined } from '@ant-design/icons';
import styles from '../../pages/OrganizationsDashboard/OrganizationsDashboard.module.css';
import {
  $bins,
  $ochvData,
  $tableControl,
  changeBinsEv,
  changeTableEv,
  getOCHVBinsFx,
} from '../../models/ochvModel/index.js';

const columns = [
  {
    title: 'БИН',
    dataIndex: 'gov_id',
    key: 'ochv_gov_id',
  },
  {
    title: 'Название',
    dataIndex: 'name',
    key: 'ochv_name',
  },
  {
    title: 'КРП',
    dataIndex: 'krp',
    key: 'ochv_krp',
  },
  {
    title: 'Регион',
    dataIndex: 'region',
    key: 'ochv_region',
  },
  {
    title: 'Плательщик ОЧВ',
    dataIndex: 'mmf_issued',
    key: 'ochv_mmf_issued',
  },
  {
    title: 'Статус оплаты ОЧВ',
    dataIndex: 'mmf_payed',
    key: 'ochv_mmf_payed',
  },
  {
    title: 'Просмотр предприятия',
    dataIndex: 'gov_id',
    key: 'ochv_actions',
    render: (gov_id) => {
      return (
        <Tooltip title="Просмотр предприятия">
          <Button
            type="primary"
            icon={<InfoOutlined />}
            href={`/view-organization/${gov_id}`}
          />
        </Tooltip>
      );
    },
  },
];

function OchvTable() {
  const [input, setInput] = useState('');
  const bins = useStore($bins);
  const changeBins = useEvent(changeBinsEv);
  const { count, data } = useStore($ochvData);
  const tableControl = useStore($tableControl);
  const changeTable = useEvent(changeTableEv);
  const loading = useStore(getOCHVBinsFx.pending);

  const onAdd = () => {
    changeBins(input);
    setInput('');
  };

  useEffect(() => {
    getOCHVBinsFx({ bins: [], table: { page: 1, limit: 10 } });
  }, []);

  return (
    <>
      <div className={styles.tableFilterContainer}>
        <div className={styles.tableFilterInput}>
          <span>БИН</span>
          <Input onChange={(e) => setInput(e.target.value)} value={input} />
        </div>
        <Button type="primary" onClick={onAdd}>
          Добавить
        </Button>
        <div className={styles.filtersItem} style={{ width: '70%' }}>
          <Select
            mode="tags"
            allowClear
            onChange={(value) => changeBins(value)}
            value={bins}
          />
        </div>
        {/* <Button onClick={() => onReset()}>Сброс</Button> */}
      </div>
      <Table
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={{
          total: count,
          onChange: (page, limit) => changeTable({ page, limit }),
          position: ['bottomCenter'],
          current: tableControl?.page || 1,
          size: tableControl?.limit || 10,
          defaultPageSize: 10,
          pageSizeOptions: [10, 20, 50, 100],
        }}
      />
    </>
  );
}

export default OchvTable;
